import { Injectable } from '@angular/core';

// Import services:
import { ImagenesRequestService } from './request/imagenes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioImagenesService {

  constructor( private requestUrl: ImagenesRequestService ) { }

  public async getResponseImagenes( objetoImagenesEntity: ObjetoImagenesEntity ) {

    try {

      const response = await this.requestUrl.getRequest(
        'consultar/consultar-imagenes',
        [ objetoImagenesEntity.codigoBaseDatos, objetoImagenesEntity.idEntidad, objetoImagenesEntity.id ]
      );

      if ( response != null ) {
        return response;
      } else {
        return null;
      }

    } catch ( exception ) {
      console.log( 'Servico Imagenes Exception:\n' + exception );
    }

  }

}

export interface ObjetoImagenesEntity {
  codigoBaseDatos: string;
  idEntidad: string;
  id: string;
}

export interface ObjetoImagenesReponseEntity {
  id: string;
  fechaVersion: string;
  imagenFirma: string;
  imagenLogo: string;
  imagenAfiliado: string;
}
